import React, { createContext, useContext, useState, useEffect } from 'react';
import { getTranslation } from './translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('id'); // Default to Indonesian

  // Load saved language preference from localStorage
  useEffect(() => {
    const savedLang = localStorage.getItem('preferred_language');
    if (savedLang && (savedLang === 'id' || savedLang === 'en')) {
      setLanguage(savedLang);
    }
  }, []);

  const switchLanguage = (lang) => {
    if (lang === 'id' || lang === 'en') {
      setLanguage(lang);
      localStorage.setItem('preferred_language', lang);
    }
  };

  const t = (key, replacements = {}) => {
    let translation = getTranslation(language, key);
    
    // Handle replacements like {{years}}
    Object.keys(replacements).forEach(placeholder => {
      translation = translation.replace(
        new RegExp(`{{${placeholder}}}`, 'g'),
        replacements[placeholder]
      );
    });
    
    return translation;
  };

  return (
    <LanguageContext.Provider value={{ language, switchLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};